import { PromptTemplateCategory } from '../types';

export const dialogue: PromptTemplateCategory = {
  title: "대화",
  icon: "💬",
  templates: [
    {
      title: "팟캐스트 인터뷰 템플릿",
      content: `두 화자 간의 팟캐스트 스타일 인터뷰를 작성하세요.
- 화자 1은 진행자입니다: [호기심 많고 열정적인 테크 저널리스트].
- 화자 2는 게스트입니다: [획기적인 논문을 발표한 저명한 AI 연구원].
- 토론 주제는 [창의적 분야에서의 인간-AI 협업의 미래]입니다.
- 톤은 [대화적이고, 통찰력 있으며, 때때로 유머러스]해야 합니다.
- 후속 질문과 일화를 포함한 자연스러운 대화를 넣으세요.

각 줄을 "Speaker 1:" 또는 "Speaker 2:" 형식으로 작성하고 그 뒤에 대화를 적으세요.`,
      mode: 'multi'
    },
    {
      title: "토론 템플릿",
      content: `반대 관점을 가진 두 화자 간의 구조화된 토론을 작성하세요.
- 화자 1은 [원격 근무가 영구적인 기본이 되어야 한다]고 주장합니다.
- 화자 2는 [혁신을 위해 사무실 협업이 필수적이다]고 주장합니다.
- 두 화자 모두 [실제 사례를 포함한 합리적인 주장]을 제시해야 합니다.
- 톤은 [존중하면서도 열정적]이어야 합니다.
- 각 화자는 상대방의 주장에 직접 응답해야 합니다.

각 줄을 "Speaker 1:" 또는 "Speaker 2:" 형식으로 작성하고 그 뒤에 대화를 적으세요.`,
      mode: 'multi'
    },
    {
      title: "언어 학습 대화 템플릿",
      content: `언어 학습자를 위한 두 화자 간의 대화를 작성하세요.
- 시나리오는 [붐비는 길거리 시장에서 음식 주문하기]입니다.
- 화자 1은 [최고의 요리를 추천하는 친절한 현지 상인]입니다.
- 화자 2는 [처음으로 현지 요리를 맛보는 여행자]입니다.
- [자연스러운 망설임, 정중한 표현, 문화적 맥락]을 포함하세요.
- 대화는 진정성 있게 느껴지고 학습자가 [일상 대화 표현]을 익히는 데 도움이 되어야 합니다.

각 줄을 "Speaker 1:" 또는 "Speaker 2:" 형식으로 작성하고 그 뒤에 대화를 적으세요.`,
      mode: 'multi'
    }
  ]
};
